import styled, { css } from "styled-components";
import MaskedInput from "react-text-mask";
import Tooltip from 'react-simple-tooltip';
import { ButtonTag } from "../../components/Button/styles";

export const OptionsSubHeading = styled.p`
  margin: 0;
  margin-bottom: 20px;
  padding: 0;

  font-weight: 700;
  font-size: 16px;
  line-height: 1;
`;

export const OptionsContainer = styled.ul`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 35px;

  li {
    display: flex;
    align-items: center;
    width: 50%;

    font-weight: 700;
  }
`;

export const CardInputContainer = styled.div`
  display: flex;
  flex-direction: column;

  transition: filter 0.3s;

  @media (min-width: 1024px) {
    flex-direction: row;
    flex-wrap: wrap;
  }
`;

export const StripeInput = styled.div`
  .StripeElement {
    padding: 15px 20px;

    border-width: 1px;
    border-style: solid;
    border-color: ${({ theme }) => theme.lightGray};
    outline: none;

    transition: border-color 0.3s;

    border-radius: inherit;

    &--focus,
    &:hover {
      border-color: ${({ theme }) => theme.blue};
    }

    &--invalid,
    &--invalid:hover {
      border-color: ${({ theme }) => theme.red};
    }
  }
`;

export const RecipientList = styled.ul`
  margin-bottom: 40px;

  border: 1px solid #ebebeb;
  border-radius: 6px;

  li {
    position: relative;

    display: flex;

    & > div {
      position: relative;

      width: 100%;

      border-right: 1px solid #ebebeb;
    }
  }

  li:not(:last-child) {
    border-bottom: 1px solid #ebebeb;
  }
`;

export const RecipientInputContainer = styled.label`
  position: relative;

  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 15px 20px;
  text-align: left;

  cursor: pointer;
`;

export const RecipientCurrency = styled.span`
  position: absolute;
  bottom: 16px;
  left: 20px;

  font-size: 16px;
  font-weight: 700;
`;

export const RecipientLabel = styled.span`
  margin: 0;
  margin-bottom: 10px;
  padding: 0;

  font-size: 14px;
  line-height: 1;
  color: #8d8d8d;
`;

export const RecipientInput = styled.input`
  margin: 0;
  padding: 0;

  font-weight: 700;
  font-size: 16px;
  line-height: 1;
  color: inherit;

  border: none;
  outline: none;
  background-color: transparent;

  &::placeholder {
    opacity: 0.5;
  }
`;

export const RecipientInputMasked = styled(MaskedInput)`
  margin: 0;
  padding: 0;

  font-weight: 700;
  font-size: 16px;
  line-height: 1;
  color: inherit;

  border: none;
  outline: none;
  background-color: transparent;

  &::placeholder {
    opacity: 0.5;
  }
`;

export const InfoInput = styled(MaskedInput)`
  width: 100%;
  margin: 0;
  padding: 15px 20px;
  padding-right: 35px;

  font-family: inherit;
  font-size: 16px;
  line-height: 1;
  color: inherit;

  border-width: 1px;
  border-style: solid;
  border-color: ${({ theme }) => theme.lightGray};
  border-radius: 6px;
  outline: none;

  transition: border-color 0.3s;

  &::placeholder {
    color: inherit;
    opacity: 0.5;
  }

  &:hover,
  &:focus {
    border-color: ${({ theme }) => theme.blue};
  }
`;

export const InfoInputContainer = styled.div`
  position: relative;

  width: 100%;

  ${({ hasError, theme }) => hasError && css`
    ${InfoInput} {
      border-color: ${theme.red};
    };
  `}
`;

export const CardInputRow = styled.div`
  display: flex;

  @media (min-width: 1024px) {
    &:nth-child(1) {
      width: 100%;
    }

    &:nth-child(2) {
      width: 66.6666%;

      ${InfoInputContainer}:first-child ${StripeInput} {
        border-bottom-left-radius: 6px;
      }
    }

    &:nth-child(3) {
      width: 33.3333%;

      ${StripeInput} {
        border-bottom-left-radius: 0 !important;
      }
    }
  }
`;

export const ClientInfoList = styled.ul`
  li {
    margin-bottom: 20px;
  }

  @media (min-width: 1024px) {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    li {
      width: 48%;
    }

    li:nth-child(3) {
      width: 100%;
    }

    li:last-child {
      width: 100%;

      button {
        width: 48%;
      }
    }
  }
`;

export const ClientInfoHeading = styled.label`
  display: block;
  margin: 0;
  margin-bottom: 10px;
  padding: 0;

  font-size: 14px;
  line-height: 1;

  cursor: pointer;
`;

export const ClientInfoNote = styled.p`
  margin: 0;
  margin-top: 10px;
  margin-bottom: 25px;
  padding: 0;

  font-size: 12px;
  line-height: 1;
  opacity: ${({ withError }) => withError ? 1 : 0.5};
  color: ${({ withError, theme }) => withError ? theme.red : 'inherit'};
`;

export const CardIcon = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 20px;

  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 100%;

  pointer-events: none;

  svg {
    width: 100%;
  }
`;

export const InfoInputErrorTooltip = styled(Tooltip)`
  position: absolute !important;
  z-index: 1;
  top: 50%;
  transform: translateY(-50%);
  right: 20px;

  display: flex !important;
`;

export const GuestLoginContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 40px;

  @media(min-width: 768px) {
    margin-bottom: 45px;
  }

  @media(min-width: 1024px) {
    margin-bottom: 20px;
  }
`;

export const GuestLoginHeading = styled.h3`
  display: none;
  margin: 0;
  padding: 0;

  @media(min-width: 768px) {
    display: block;
    font-size: 30px;
    line-height: 1;
  }
`;

export const GuestLoginButtonContainer = styled.div`
  button {
    padding: 15px 30px;
  }
`;

export const PaymentProcessError = styled.p`
  width: 100%;
  margin: 0;
  margin-top: 10px;
  padding: 0;

  font-size: 16px;
  line-height: 1.2;
  color: ${({ theme }) => theme.red};
`;

export const CheckboxDescription = styled.p`
  font-size: 14px;
  color: ${({ theme, hasError }) => hasError ? theme.red : theme.black};
`;

export const CheckboxList = styled.ul`
  li ${CheckboxDescription} {
    margin: 0;
    line-height: 20px;
  }

  li:not(:last-child) {
    margin-bottom: 10px;
  }

  a {
    color: ${({ theme }) => theme.blue};

    transition: color 0.3s;

    &:hover {
      color: ${({ theme }) => theme.black};
    }
  }
`;

export const PayButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 35px;

  @media(min-width: 768px) {
    justify-content: flex-start;
    margin-top: 60px;
  }
`;

export const PayButton = styled(ButtonTag)`
  max-width: 250px;
  width: 100%;
`;

export const RulesDropdown = styled.ul`
  margin-top: 10px;
  padding-left: 28px;

  li {
    font-size: 14px;
    line-height: 20px;

    &:not(:last-child) {
      margin-bottom: 10px;
    }

    &::before {
      content: "";

      display: inline-block;
      vertical-align: middle;
      width: 4px;
      height: 4px;
      margin-right: 5px;

      background-color: #9a9a9a;
      border-radius: 50%;
    }
  }
`;

export const baseInputStyle = {
  base: {
    fontSize: '16px',
    fontWeight: '400',
    color: '#5a5a5a',
    fontFamily: '"Gilroy", Arial, "Helvetica Neue", Helvetica, sans-serif',
    '::placeholder': {
      color: 'rgba(90, 90, 90, 0.5)',
    },
  },
  invalid: {
    color: '#FF6F5A',
  },
};
